module.exports = __webpack_public_path__ + "img/login-gif.3357c18f.gif";